import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../common/api";
import { Button, Col, Divider, Flex, Row, Space, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import PermissionRequired from "../common/PermissionRequired";
import { date2locale } from "../common/common";
import Toolbar from "../common/Toolbar";
import { UserInfoContext } from "../FetchUserInfo";

const columns = [
    {
        title: "ID",
        ellipsis: true,
        key: "id",
        dataIndex: "id",
        width: 70,
        render: (x) => <Link to={`${x}`}>{x}</Link>,
    },
    {
        title: "Nome",
        key: "name",
        dataIndex: "name",
        ellipsis: true,
        width: 250,
    },
    {
        title: "Stato",
        key: "state",
        dataIndex: "state",
        ellipsis: true,
        render: (x) => ({ DRAFT: "Bozza", CONFIRMED: "Confermata" })[x] ?? "",
        width: 120,
    },
    {
        title: "Data pagamento",
        key: "paymentDate",
        dataIndex: "paymentDate",
        render: date2locale,
        width: 500,
        ellipsis: true,
    },
];

export default function () {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const navigate = useNavigate();
    const user = useContext(UserInfoContext);

    useEffect(() => {
        setLoading(true);
        axiosInstance
            .get("paycheckBatchBankTransfer")
            .then(({ data }) => setData(data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <Flex vertical gap={0}>
            <Toolbar
                selectedKeys={selectedRowKeys}
                addText={"Nuova distinta"}
                addAction={
                    user?.permissions.includes("batchTransfer.create")
                        ? () => navigate("new")
                        : null
                }
                extra={(keys) => (
                    <>
                        {user?.permissions.includes("batchTransfer.confirm") && (
                            <Button
                                type="link"
                                disabled={
                                    keys.length !== 1 ||
                                    data.filter((x) => x.id === keys[0])[0].state === "CONFIRMED"
                                }
                                onClick={() => navigate(`${keys[0]}/confirm`)}
                            >
                                Conferma distinta
                            </Button>
                        )}
                    </>
                )}
                deleteAction={
                    user?.permissions.includes("batchTransfer.delete")
                        ? (keys) => {
                              axiosInstance
                                  .delete(`paycheckBatchBankTransfer/${keys[0]}`)
                                  .then(() => setData(data.filter((x) => x.id !== keys[0])));
                          }
                        : null
                }
            />
            <Table
                columns={columns}
                size="small"
                tableLayout={"fixed"}
                dataSource={data.map((x) => ({ ...x, key: x.id }))}
                rowKey="id"
                loading={loading}
                pagination={{
                    showTotal: (count) => `Totale: ${count}`,
                }}
                scroll={{ x: columns.reduce((acc, x) => x.width + acc, 0) }}
                rowSelection={{
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                    type: "radio",
                }}
                onRow={(record) => {
                    return {
                        onClick: () => {
                            setSelectedRowKeys([record.key]);
                        }, // click row
                    };
                }}
            />
        </Flex>
    );
}
